import { GoogleSearch } from "features/GoogleSearch";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Form } from "shared/ui";

function TravelLineForm({
  form,
  disabled,
  uploadedFiles,
  favouritePlacesOptions,
  traveIntervalTypes,
  handleSubmit,
  intervalType,
  vehicleOptions,
  validations,
  isPrivateCar,
  isDomesticInterval,
  placeOfWorkIsAllowed,
}) {
  const { t } = useTranslation("TravelLine");
  return (
    <Form form={form} onSubmit={handleSubmit} className="py-5">
      <Row>
        <Form.Select
          label={t("labels.transport_type")}
          name="interval_type_id"
          displayAs={Col}
          isDisabled={disabled}
          isSearchable={false}
          options={traveIntervalTypes}
        />
        {intervalType?.label === "Car" && (
          <Form.Select
            label={t("labels.car_type")}
            name="vehicle_info"
            isDisabled={disabled}
            displayAs={Col}
            isSearchable={false}
            options={vehicleOptions}
            md={3}
          />
        )}
        {isPrivateCar && (
          <Form.NumericInput
            label={t("labels.distance")}
            name="distance"
            addon="KM"
            disabled={disabled}
            displayAs={Col}
            allowNegative={false}
            allowLeadingZeros={false}
            thousandSeparator=","
            md={3}
          />
        )}
      </Row>
      <Row>
        <Col md>
          <div className="text-center fw-bolder py-4">{t("departure")}</div>
          <GoogleSearch
            defaultOptions={favouritePlacesOptions}
            label={t("labels.departure_country")}
            name="start_place_id"
            isDisabled={disabled}
          />
        </Col>
        <Col md>
          <div className="text-center fw-bolder py-4">{t("arrival")}</div>
          <GoogleSearch
            defaultOptions={favouritePlacesOptions}
            label={t("labels.arrival_country")}
            name="end_place_id"
            isDisabled={disabled}
          />
          {placeOfWorkIsAllowed && (
            <Form.Check
              type="switch"
              disabled={disabled}
              name="place_of_work"
              label={t("labels.working_place_in_destination")}
              className="mt-2"
            />
          )}
        </Col>
      </Row>
      <Row className="mt-4">
        <Form.DateTimePicker
          name="start_time"
          label={t("labels.start_time")}
          displayAs={Col}
          disabled={disabled}
          md={3}
        />
        {!isDomesticInterval && (
          <Form.DateTimePicker
            name="border_crossing_time"
            label={t("labels.border_crossing_time")}
            disabled={disabled || intervalType?.label === "Plane"}
            displayAs={Col}
            md={3}
          />
        )}
        <Form.DateTimePicker
          name="end_time"
          label={t("labels.end_time")}
          disabled={disabled}
          displayAs={Col}
          md={3}
        />
      </Row>
      <Row className="mt-4 justify-content-end">
        <Form.FilesInput
          label={t("labels.attachments")}
          name="attachments"
          disabled={disabled}
          uploadedFiles={uploadedFiles}
          maxSize={validations?.max_allowed_file_size_in_bytes}
          max={validations?.attachments_count_rules.data?.max}
          min={validations?.attachments_count_rules.data?.min}
          acceptedExtensions={validations?.attachments_allowed_file_types.data}
          displayAs={Col}
        />
      </Row>
    </Form>
  );
}

export default TravelLineForm;
